import { CommitteeReportType, IBaseQueryParameters } from '../index.js'

/**
 * This interface defines the query parameters for the endpoints available in
 * the `CommitteeReports` endpoint class.
 */
export interface ICommitteeReportQueryParameters extends IBaseQueryParameters {
  /** Set to `true` to filter for conference reports. */
  conference?: boolean
}

/**
 * This interface defines the path parameters for the endpoints available in the
 * `CommitteeReports` endpoint class.
 */
export interface ICommitteeReportPathParameters {
  /** The congress number. For example, the value can be `117`. */
  congress?: number

  /** The type of report. Value can be `hrpt`, `srpt`, or `erpt`. */
  reportType?: CommitteeReportType

  /** The report’s assigned number. For example, the value can be `3076`. */
  reportNumber?: number
}
